import classNames from 'classnames';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import DataItem from 'components/DataItem';
import DefaultActionButtons from 'components/DefaultActionButtons';
import Text from 'components/typography/Text';
import {
  BUTTON_TYPE_BUTTON,
  BUTTON_TYPE_SUBMIT,
} from 'shared/constants/common';
import { getFullname, displayDate } from 'shared/helpers/common';
import PassportModal from '../../documentPage/PassportModal';

export default function PassportItem({
  onPassportUpdate,
  formDropdownConfig,
  data = {},
  bookingRefOrId,
}) {

  const { componentConfig, selectedBooking } = useSelector(
    (state) => state.ui,
  );

  const [isEditModalOpen, setEditModalState] = useState(false);

  const {
    passportNumber = '',
    citizenship = '',
    dateOfBirth = '',
    passportExpiry = '',
    firstName = '',
    middleName = '',
    lastName = '',
  } = data;

  const isCruiseBooking = selectedBooking?.cruises?.length > 0;

  const onPassportUpdateHandler = (id, updatedData) => {
    onPassportUpdate?.(id, updatedData);
  };
  
  return (
    <>
      <div className="w-full my-4">
        <div className="rounded-[10px] overflow-hidden">
          <div className={classNames('bg-white rounded-t-lg p-2 lg:p-[25px] pb-0')}>
            <Text className="font-medium text-[22px] mb-2">
              {getFullname({ firstName, middleName, lastName })}
            </Text>

            <div className="flex flex-wrap w-full text-[16px] leading-[20px]">
              <DataItem label="Passport number" value={passportNumber} isHalf />
              <DataItem label="Citizenship" value={citizenship} isHalf />
              <DataItem
                label="Date of birth"
                value={displayDate(dateOfBirth, '-', undefined, true)}
                isHalf
              />
              <DataItem
                label="Passport expiry date"
                value={displayDate(passportExpiry, '-', undefined, true)}
                isHalf
              />
            </div>
          </div>
          <div>
            <DefaultActionButtons
              onPrimaryButtonClick={() => setEditModalState(true)}
              secondaryButtonLabel="Delete"
              primaryButtonLabel={componentConfig.bookingPassportsUpdateEnabled ? "View / Edit" : "View"}
              containerClassName="border-t p-4 bg-white rounded-b-lg"
              secondaryButtonClassName="px-4"
              primaryButtonClassName="px-4"
              primaryButtonType={BUTTON_TYPE_BUTTON}
              secondaryButtonType={BUTTON_TYPE_SUBMIT}
              hideSecondaryButton
            />
          </div>
        </div>
      </div>
      <PassportModal
        isOpen={isEditModalOpen}
        setModalState={setEditModalState}
        data={data}
        fullname={getFullname({ firstName, lastName })}
        onPassportUpdate={onPassportUpdateHandler}
        formDropdownConfig={formDropdownConfig}
        passportType="passenger"
        bookingRefOrId={bookingRefOrId}
        isCruiseBooking={isCruiseBooking}
      />
    </>
  );
}
